import moment from 'moment';
import {
  MessageType
} from '@/lib/utilities/enums.js';

export function convertIdToPubNubKind(id) {
  var self = this;

  if (!id || id.length === 0)
    return "";

  return id.replace(/:/g, "-");
};


export function convertIdToMotoKind(id) {
  var self = this;

  if (!id || id.length === 0)
      return "";

  return id.replace(/-/g, ":");
};

export function isEmpty(obj) {
  for (var key in obj) {
      if (obj.hasOwnProperty(key))
          return false;
  }
  return true;
}

export function alphabeticSort(array) {
  return array.sort(function compare(a, b) {
    if (a < b)
      return -1;
    if (a > b)
      return 1;
    return 0;
  })
}

export function alphabeticSortOnKey(array, key) {
  let rtn = array.sort(function compare(a, b) {
    if (a[key] < b[key])
      return -1;
    if (a[key] > b[key])
      return 1;
    return 0;
  })

  return rtn;
}

export function convertToMotoMessage(message) {
  try {
    if (!message) {
      console.log("Empty message: ", message);
      return null;
    }
    var motoMSG = null;

    //Via history
    if (message.entry) {
      if (message.entry.msg)
        motoMSG = message.entry.msg;
      //else if (message.entry.entry && message.entry.entry.msg)
      //    msg = message.entry.entry.msg;
    } else if (message.message && message.message.msg) //Via listener
    {
        console.log('hello world')
      motoMSG = message.message.msg;
    } else if (message.MessageId)
      motoMSG = message;

    if (motoMSG) {
      if (typeof (motoMSG) === 'string')
        motoMSG = JSON.parse(motoMSG);

      //Ignore old test messages
      if (!motoMSG || !motoMSG.MessageId)
        return;

      if (message.timetoken)
        motoMSG.Timetoken = message.timetoken * 1; //PubNub sends the timetoken as string
      else {
        motoMSG.NoPubnubTimestamp = true;
        motoMSG.Timetoken = moment(motoMSG.CreatedUtc).valueOf() * 10000; //For api message response in view
      }

      motoMSG.CreatedTimetoken = moment(motoMSG.CreatedUtc).valueOf() * 10000;
      // motoMSG.Timetoken = message.timetoken ?
      //     message.timetoken * 1 //PubNub sends the timetoken as string
      //     :
      //     moment(motoMSG.CreatedDT).valueOf() * 10000; //For api message response in view
      motoMSG.IsSystem = motoMSG.MessageType === MessageType.System;
      motoMSG.IsFirstUnread = false;

    //   if (motoMSG.SenderId && store.getters.appUsers && store.getters.appUsers.length > 0) {
    //     motoMSG.Sender = store.getters.appUsers.find(function (user) {
    //       return user.Id == motoMSG.SenderId;
    //     });
    //   }

      var userMessage = null;
      if (motoMSG.Messages && motoMSG.Messages.length > 0)
        userMessage = motoMSG.Messages[0];

      //TODO: Find matching message for user's language
      // for (var msg of motoMSG.Messages) {
      //     // if (msg.Text)
      //     //     msg.Text = msg.Text.replace(/\r*\n/g, "<br/>");
      //     if (userMessage == null && (!store.getters.user.Language || msg.Language == store.getters.user.Language)) {
      //         userMessage = msg;
      //         break;
      //     }
      // }

      motoMSG.MessageText = userMessage && userMessage.Text ? userMessage.Text : "";

    //   if (motoMSG.AttachmentFile && motoMSG.AttachmentFile.Payload && typeof (motoMSG.AttachmentFile.Payload) != 'object')
    //     motoMSG.AttachmentFile.Payload = JSON.parse(motoMSG.AttachmentFile.Payload);

    //   motoMSG.MessageTokenLines = generateMessageTokenLines(motoMSG.MessageText);

      return motoMSG;
    }
  } catch (err) {
    console.log(err);
    console.log(message);
  }

  return null;
}





// WEBPACK FOOTER //
// ./src/lib/utilities/index.js